module.exports = __webpack_public_path__ + "fonts/Inter-Medium.66f0ef61.woff";